/* eslint-disable */
export default {
  dial: 'Marcación',
  message: 'Mensaje',
  transfer: 'Transferir',
} as const;

// @key: @#@"dial"@#@ @source: @#@"Dial"@#@
// @key: @#@"message"@#@ @source: @#@"Message"@#@
// @key: @#@"transfer"@#@ @source: @#@"Transfer"@#@
